import React from 'react';

import { useFormState } from 'react-final-form';

import { ProjectIssueTypesContext } from '@qality/common-components/src/lib/ProjectIssueTypesProvider';
import {
  QAlityOptions,
  getQAlityFields,
} from '@qality/common-components/src/molecules/ImportTestCasesForm';

import { FieldMapperView } from './FieldMapper.view';

export const FieldMapper = () => {
  const { submitFailed, errors, values } = useFormState();
  const { mappingGeneralError: { missingFields = [] } = {} } = errors;

  const { projectIssueTypes } = React.useContext(ProjectIssueTypesContext);

  const JIRAOptions = getQAlityFields(projectIssueTypes).filter(
    (f) => f.required
  );
  const OtherOptions = getQAlityFields(projectIssueTypes).filter(
    (f) => !f.required
  );

  OtherOptions.unshift({
    label: 'Test Data',
    value: 'TestStep.Data',
    required: false,
  });

  const alreadySelectedFieldKeys = values.mapping
    .map((field) => field.to?.value)
    .filter(Boolean);

  const filterOutOptions = (fields) => {
    const filteredOptions = fields.filter(
      (f) => !alreadySelectedFieldKeys.includes(f.value)
    );

    if (fields.length > 0 && filteredOptions.length === 0) {
      return [
        {
          label: 'All Selected',
          value: 'ALL_SELECTED',
          isDisabled: true,
        },
      ];
    }

    return filteredOptions;
  };

  const groupedOptions = [
    {
      label: "Don't map this field",
      value: null,
    },
    {
      label: 'Required by QAlity',
      options: filterOutOptions(QAlityOptions),
    },
    {
      label: 'Required by JIRA',
      options: filterOutOptions(JIRAOptions),
    },
    {
      label: 'Other',
      options: filterOutOptions(OtherOptions),
    },
  ];

  const mandatorySelectionFields = [...QAlityOptions, ...JIRAOptions].map(
    (f) => f.label
  );

  const hasError = submitFailed && errors.mappingGeneralError;

  return (
    <FieldMapperView
      hasError={hasError}
      options={groupedOptions}
      missingFields={missingFields}
      mandatorySelectionFields={mandatorySelectionFields}
      emptyMapping={values.mapping.length === 0}
    />
  );
};
